import React, { useState } from "react";
import {
  HEADING1,
  SL_NO,
  DWNLD_FL,
  t,
  tAboutUsCommon,
} from "../../translations/AboutUs/AnnualAdministrationReport";

function AnnualAdministrationReport() {
  const [activeTab, setActiveTab] = useState("KSRTC");

  return (
    <div
      style={{
        width: "80%",
        display: "flex",
        alignItems: "flex-start",
        justifyContent: "flex-start",
        flexDirection: "column",
        paddingRight: 10,
      }}
      className="annual-administration-report"
    >
      <div
        style={{
          fontSize: 20,
          fontWeight: 600,
          textAlign: "left",
          paddingBottom: 15,
        }}
      >
        {t(HEADING1)}
      </div>
      <div style={{ display: "flex", gap: 3, fontSize: 14 }}>
        <div
          className={`tab ${activeTab == "KSRTC" ? "activeTab" : ""}`}
          onClick={() => setActiveTab("KSRTC")}
        >
          KSRTC
        </div>
        <div
          className={`tab ${activeTab == "BMTC" ? "activeTab" : ""}`}
          onClick={() => setActiveTab("BMTC")}
        >
          BMTC
        </div>
        <div
          className={`tab ${activeTab == "NEKRTC" ? "activeTab" : ""}`}
          onClick={() => setActiveTab("NEKRTC")}
        >
          NEKRTC
        </div>
        <div
          className={`tab ${activeTab == "NWKRTC" ? "activeTab" : ""}`}
          onClick={() => setActiveTab("NWKRTC")}
        >
          NWKRTC
        </div>
      </div>

      {activeTab == "KSRTC" && (
        <table>
          <tbody>
            <tr>
              <th style={{ backgroundColor: "#e5f3ff", fontWeight: 700 }}>
                {t(SL_NO)}
              </th>
              <th style={{ backgroundColor: "#e5f3ff", fontWeight: 700 }}>
                {t(DWNLD_FL)}
              </th>
            </tr>
            <tr>
              <td>1</td>
              <td>{t(HEADING1)} 2018-2019</td>
            </tr>
            <tr>
              <td>2</td>
              <td>{t(HEADING1)} 2017-2018</td>
            </tr>
            <tr>
              <td>3</td>
              <td>{t(HEADING1)} 2016-2017</td>
            </tr>
            <tr>
              <td>4</td>
              <td>2015-16: AAR KSRTC</td>
            </tr>
            <tr>
              <td>5</td>
              <td>2014-15: AAR KSRTC Part-01 Part-02</td>
            </tr>
            <tr>
              <td>6</td>
              <td>2013-14: AAR KSRTC</td>
            </tr>
            <tr>
              <td>7</td>
              <td>2012-13: AAR KSRTC</td>
            </tr>
            <tr>
              <td>8</td>
              <td>2011-12: AAR KSRTC</td>
            </tr>
            <tr>
              <td>9</td>
              <td>2010-11: AAR KSRTC</td>
            </tr>
            <tr>
              <td>10</td>
              <td>2009-10: AAR KSRTC</td>
            </tr>
            <tr>
              <td>11</td>
              <td>2008-09: AAR KSRTC</td>
            </tr>
            <tr>
              <td>12</td>
              <td>2007-08: AAR KSRTC</td>
            </tr>
          </tbody>
        </table>
      )}

      {activeTab == "BMTC" && (
        <table>
          <tr>
            <th style={{ backgroundColor: "#e5f3ff", fontWeight: "700" }}>
              Sl No.
            </th>
            <th style={{ backgroundColor: "#e5f3ff", fontWeight: "700" }}>
              Download File
            </th>
          </tr>
          <tr>
            <td>1</td>
            <td>1. {t(HEADING1)}-BMTC</td>
          </tr>
        </table>
      )}
      {activeTab == "NEKRTC" && (
        <table>
          <tr>
            <th style={{ backgroundColor: "#e5f3ff", fontWeight: "700" }}>
              Sl No.
            </th>
            <th style={{ backgroundColor: "#e5f3ff", fontWeight: "700" }}>
              Download File
            </th>
          </tr>
          <tr>
            <td>1</td>
            <td>1.{t(HEADING1)}-NEKRTC</td>
          </tr>
        </table>
      )}
      {activeTab == "NWKRTC" && (
        <table>
          <tr>
            <th style={{ backgroundColor: "#e5f3ff", fontWeight: "700" }}>
              Sl No.
            </th>
            <th style={{ backgroundColor: "#e5f3ff", fontWeight: "700" }}>
              Download File
            </th>
          </tr>
          <tr>
            <td>1</td>
            <td>1.{t(HEADING1)}-NWKRTC</td>
          </tr>
        </table>
      )}
    </div>
  );
}

export default AnnualAdministrationReport;
